import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const serRoutes: Routes = [
  {
    path: 'dashboard',
    title: 'Dashboard de Serviços',
    loadComponent: () =>
      import('../pages/ser/dashboard/dashboard-servico/dashboard-servico.component').then(
        (component) => component.DashboardServicoComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'apontamento',
    loadChildren: () =>
      import('../pages/ser/apontamento/apontamento.module').then(
        (module) => module.ApontamentoModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import('../pages/cad/cadastro-generico/cadastro-generico.module').then(
        (module) => module.CadastroGenericoModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'despesa',
    loadChildren: () =>
      import('../pages/ser/despesa/despesa-routing.module').then(
        (module) => module.DespesaRoutingModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'projeto',
    loadChildren: () =>
      import('../pages/ser/projeto/projeto.module').then((module) => module.ProjetoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'projeto-valor',
    loadChildren: () =>
      import('../pages/ser/projeto-valor/projeto-valor.module').then(
        (module) => module.ProjetoValorModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then((module) => module.SaldoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'tabela-preco',
    loadChildren: () =>
      import('../pages/cml/tabela-preco/tabela-preco.module').then(
        (module) => module.TabelaPrecoModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'lista-preco',
    loadChildren: () =>
      import('../pages/cml/lista-preco/lista-preco.module').then(
        (module) => module.ListaPrecoModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then((module) => module.IndiceModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'manutencao-fa',
    loadChildren: () =>
      import('../pages/ser/manutencao-fa/manutencao-fa.module').then(
        (module) => module.ManutencaoFaModule,
      ),
    canActivate: [AuthGuard],
  },
];
